const EventMessage = {
	Changed: 'changed',
	Added: 'added',
	Removed: 'removed',
	Result: 'result',
	Connected: 'connected',
	Connect: 'connect',
	NoSub: 'nosub',
	UnSub: 'unsub',
	Pong: 'pong',
	Sub: 'sub',
	Ping: 'ping',
	Method: 'method',
}

const Url = {
	LOGIN: '/login.do',


	SAVE_MESSAGE: '/api/front/message/save',  // 保存留言
	GET_ARTICLE_LIST: '/api/front/article/list',  // 企业新闻
	GET_ARTICLE: '/api/front/article',  // 企业新闻详情

}


export { EventMessage, Url }
